import { getAxiosInstance } from '../client';
/** Typed API functions for feature toggles */
export const featureToggleQueries = {
    /** GET /feature-toggle/office-location/:officeLocationId */
    getByOfficeLocation: (officeLocationId) => getAxiosInstance()
        .get(`/feature-toggle/office-location/${officeLocationId}`)
        .then((r) => r.data),
};
/** Query keys for feature toggles - use with TanStack Query */
export const featureToggleKeys = {
    all: () => ['feature-toggle'],
    byOfficeLocation: (officeLocationId) => ['feature-toggle', 'office-location', officeLocationId],
};
//# sourceMappingURL=feature-toggle.queries.js.map